import React from 'react';
import PantallaPrincipalMaxwell from '../Screens/PantallaPrincipal/components/PantallaPrincipalMaxwell.jsx';
import MaxwellIA from '../Screens/MaxwellIA/components/ContainerMaxwellIA';
/* Integración MAXWELL */
import TDCobranzas from '../Screens/IntegracionPantallas/components/containers/ContainerTDCobranzas';
import TDConsumos from '../Screens/IntegracionPantallas/components/containers/ContainerTDConsumos';
import TDGeneral from '../Screens/IntegracionPantallas/components/containers/ContainerTDGeneral';
import TDMora from '../Screens/IntegracionPantallas/components/containers/ContainerTDMora';
import TDResumenes from '../Screens/IntegracionPantallas/components/containers/ContainerTDResumenes';
import TPChurn from '../Screens/IntegracionPantallas/components/containers/ContainerTPChurn';
import TPReactivacion from '../Screens/IntegracionPantallas/components/containers/ContainerTPReactivacion';

const ApplicationRoutes = {Routes: [
    /* Integración MAXWELL */
    {path: "/:product/:category/:program/Cobranzas",exact: true,component: TDCobranzas,isPrivate: true},
    {path: "/:product/:category/:program/Consumos",exact: true,component: TDConsumos,isPrivate: true},
    {path: "/:product/:category/:program/General",exact: true,component: TDGeneral,isPrivate: true},
    {path: "/:product/:category/:program/Mora",exact: true,component: TDMora,isPrivate: true},
    {path: "/:product/:category/:program/Resumenes",exact: true,component: TDResumenes,isPrivate: true},
    {path: "/:product/:category/:program/Churn",exact: true,component: TPChurn,isPrivate: true},
    {path: "/:product/:category/:program/Reactivacion",exact: true,component: TPReactivacion,isPrivate: true},
    {path: "/:product/:category/:program/MaxwellIA",exact: true,component: MaxwellIA,isPrivate: true},
    {path: "/Maxwell/",exact: true,component: PantallaPrincipalMaxwell,isPrivate: true},
]};
export default ApplicationRoutes;
